import React from "react";
import { Image } from "react-bootstrap";

const PaymentFailed = () => {
  return (
    <div className="payment-failed-content--detail text-center page-height">
      <Image
        alt="Payment failed illustration"
        className="payment-failed-image mb-3"
        src="/images/payment-failed.svg"
        fluid
      />

      <h4>Oops! Something went wrong.</h4>
      <span>We were unable to process your payment.</span>
    </div>
  );
};

export default PaymentFailed;
